<template>
  <div class="wrapper-left top-37.5 left-8.5 bottom-8.5 fixed">
    <div class="home relative flex flex-col gap-2.5 cursor-pointer" @click="setRoute('main')">
      <svg class="mr-5 transform rotate-90" width="12" height="13" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 6L7 12L13 6" stroke="#323749" stroke-linejoin="round"/>
        <path d="M6.99998 0V12" stroke="#323749" stroke-linejoin="round"/>
      </svg>
      <p class="uppercase font-medium fz-10" style="letter-spacing: 0.1rem; color:rgba(110, 117, 141, 1) ">{{ text.home }}</p>
    </div>
    <div class="h-px w-5 absolute" style="top: 14.88%; background:rgba(151, 163, 203, 0.3);"></div>
    <div class="h-px w-5 absolute" style="top: 26.78%; background:rgba(151, 163, 203, 0.3);"></div>
    <div class="h-px w-2.5 absolute" style="top: 60.95%; background:rgba(151, 163, 203, 0.3);"></div>
    <div class="h-px w-5 absolute" style="top: 100%; background:rgba(151, 163, 203, 0.3);"></div>
  </div>
  <div class="wrapper-right top-37.5 right-8.5 bottom-8.5 fixed">
    <div class="h-px w-7.5 absolute right-0" style="top: 0; background:rgba(151, 163, 203, 0.3);"></div>
    <div class="h-[3px] w-1.5 absolute right-0" style="top: 26.90%; background:rgba(151, 163, 203, 0.3);"></div>
    <div class="h-px w-7.5 absolute right-0" style="top: 100%; background:rgba(151, 163, 203, 0.6);"></div>
  </div>

  <div class="wrapper-bottom fixed bottom-8.5 transform transition cursor-pointer z-50" style="left: 12.3%" @click="$emit('nextSlide')">
    <svg width="14" class="transform transition duration-800" :class="slide === 5 ? 'rotate-180' : ''" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 6L7 12L13 6" stroke-linejoin="round"/>
      <path d="M6.99998 0V12" stroke-linejoin="round"/>
    </svg>
    <p class="fz-10 font-medium uppercase mt-2.5" style="letter-spacing: 0.3em">{{ slide !== 5 ? text.scroll : text.back }}</p>
  </div>
</template>

<script>
import {mapMutations, mapState} from "vuex";

export default {
  name: "agencyWrappers",
  emits: ['nextSlide'],
  props: ['slide'],
  computed:{
    text(){
      return require("@/assets/text/fixWrappers/" + this.lang + ".json")
    },
    ...mapState(['lang'])
  },
  methods:{
    ...mapMutations(['setRoute'])
  }
};
</script>

<style scoped lang="scss">
.wrapper-bottom{
  svg{
    path{
      transition: all linear .3s;
      stroke: rgba(151, 163, 203, 0.6);
    }
  }
  p{
    transition: all linear .3s;
    color: rgba(151, 163, 203, 0.6);
  }
}
.wrapper-bottom:hover{
  svg{
    path{
      transition: all linear .3s;
      stroke: white;
    }
  }
  p{
    transition: all linear .3s;
    color: white;
  }
}
</style>
